export type TimelineSeekPlayer = {
  slideTo?: (frame?: number) => Promise<void>;
  seekToAndKeepPauseOrPlay?: (frame?: number) => Promise<void>;
  seekTo?: (frame?: number, play?: boolean) => Promise<void>;
  playing?: boolean;
};

export type TimelineSeek = (frame: number) => Promise<void> | undefined;

export function getTimelineSeek(
  player?: TimelineSeekPlayer
): TimelineSeek | undefined {
  if (typeof player?.seekToAndKeepPauseOrPlay === "function") {
    return (frame) => player.seekToAndKeepPauseOrPlay?.(frame);
  }

  if (typeof player?.seekTo === "function") {
    return (frame) => player.seekTo?.(frame, player.playing);
  }

  if (typeof player?.slideTo === "function") {
    return (frame) => player.slideTo?.(frame);
  }

  return undefined;
}
